import { Link } from "react-router-dom";

const footerGroups = [
  {
    title: "浏览",
    links: [
      { label: "首页", path: "/" },
      { label: "全部分类", path: "/category" },
      { label: "搜索动漫", path: "/search" },
      { label: "热门排行", path: "/category?sort=hot" },
    ],
  },
  {
    title: "分类",
    links: [
      { label: "热血动漫", path: "/category?genre=热血" },
      { label: "恋爱番剧", path: "/category?genre=恋爱" },
      { label: "冒险奇幻", path: "/category?genre=冒险" },
      { label: "治愈日常", path: "/category?genre=治愈" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "关于我们", path: "/about" },
      { label: "联系方式", path: "/about" },
      { label: "使用说明", path: "/about" },
    ],
  },
];

const friendLinks = ["星屑动画", "青丘制作", "花音企划", "暖灯社", "云笺工作室"];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-100/60">
      <div className="mx-auto px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2" aria-label="樱花动漫网站首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flower-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                樱花动漫
              </span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              樱花动漫网站是专注于热门动漫资源在线观看与信息展示的平台，收录最新动画与经典动漫作品，陪你一起追番、找番、聊番。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold text-foreground-900">{group.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-primary-200/70 pt-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm text-foreground-500">
              <span className="text-foreground-700">友情链接：</span>
              {friendLinks.map((name) => (
                <span key={name} className="whitespace-nowrap text-foreground-600">
                  {name}
                </span>
              ))}
            </div>
            <p className="text-xs text-foreground-500">
              © 2026 樱花动漫网站 · 本站内容均为演示数据，仅供学习交流
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}